import type { CityConfig } from "../city-template/types";

export const jacksonConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Jackson County Clerk", href: "https://www.co.jackson.mi.us/clerk", description: "Jackson County Clerk — marriage license issuance" },
    { label: "Divorce Records — Jackson County Clerk", href: "https://www.co.jackson.mi.us/clerk", description: "Jackson County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Jackson",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "jackson-mi",
  route: "/jackson-mi",
  title: "Emergency Passport Jackson, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Jackson, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Jackson, Parma, Spring Arbor, Michigan Center, and all Jackson County residents. A+ BBB rated courier service serving South Central Michigan.",
  h1: "Emergency & Expedited Passport Services in Jackson, MI",
  heroSubtitle: "Jackson travelers — from manufacturing professionals to college students at Spring Arbor to families visiting the Irish Hills — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. No need to drive to Detroit or Chicago — we handle everything by courier. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Jackson%20Michigan%20cityscape%20with%20the%20Grand%20River%20flowing%20through%20the%20downtown%20area%2C%20historic%20courthouse%20building%20visible%2C%20tree-lined%20streets%20and%20neighborhoods%20surrounding%20the%20city%20center%2C%20soft%20warm%20golden%20afternoon%20light%2C%20calm%20small-city%20atmosphere%20with%20autumn%20foliage%2C%20Michigan%20small-town%20charm%2C%20no%20text%20no%20people%2C%20clean%20simple%20sky%20background%2C%20professional%20architectural%20photography&width=1800&height=700&seq=jackson-mi-hero-001&orientation=landscape",
  heroImageAlt: "Jackson Michigan downtown cityscape with the Grand River and historic courthouse",
  geoPosition: "42.2459;-84.4014",
  geoPlacename: "Jackson, Michigan",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 80 miles east of Jackson — about 1 hour 15 minutes via I-94",
  },
  nearbyCitiesZips: [
    { name: "Jackson", zips: "49201, 49202, 49203, 49204" },
    { name: "Parma", zips: "49269" },
    { name: "Spring Arbor", zips: "49283" },
    { name: "Michigan Center", zips: "49254" },
    { name: "Napoleon", zips: "49261" },
    { name: "Grass Lake", zips: "49240" },
    { name: "Hanover", zips: "49241" },
    { name: "Concord", zips: "49237" },
    { name: "Springport", zips: "49284" },
    { name: "Albion", zips: "49224" },
    { name: "Marshall", zips: "49068, 49069" },
    { name: "Battle Creek", zips: "49014, 49015, 49016, 49017, 49018, 49037" },
    { name: "Lansing", zips: "48901, 48906, 48909, 48910, 48911, 48912, 48915, 48917, 48921, 48933, 48950" },
    { name: "Adrian", zips: "49221" },
    { name: "Coldwater", zips: "49036" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-truck-line", title: "No Driving to Detroit", desc: "Ship from any UPS or FedEx in Jackson — we handle the agency visit" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — stay home while we do the work" },
  ],
  internalLinks: [
    { name: "Expedited passport in Lansing, MI", route: "/lansing-mi" },
    { name: "Emergency passport services in Ann Arbor, MI", route: "/ann-arbor" },
    { name: "Urgent passport processing in Kalamazoo, MI", route: "/kalamazoo" },
    { name: "Michigan passport services overview", route: "/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Jackson, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the 80-mile drive to Detroit. Jackson residents can ship from any UPS or FedEx in Jackson County.",
  fpcOfficeDistance: "Serving Jackson, Parma, Spring Arbor, Michigan Center, Napoleon, Grass Lake, Hanover, Concord, Springport, and all of Jackson County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Jackson and South Central Michigan. From the historic downtown Jackson district to the Spring Arbor University campus, from the Michigan International Speedway to the Irish Hills — we serve all of Jackson County and neighboring counties. Our courier service is especially valuable for Jackson residents who would otherwise need to drive 80 miles to the Detroit Passport Agency.",
  nearbyCitiesIntro: "We serve Jackson and all of Jackson County including Parma, Spring Arbor, Michigan Center, Napoleon, Grass Lake, Hanover, Concord, and Springport. We also serve neighboring Calhoun County (Battle Creek, Marshall, Albion), Washtenaw County (Ann Arbor, Saline), and Ingham County (Lansing, East Lansing).",
  howItWorksIntro: "Most Jackson travelers complete everything online and ship documents overnight. No driving 80 miles to the Detroit Passport Agency — our registered couriers handle the agency submission for you.",
  mistakesIntro: "Jackson County travelers often discover passport issues close to departure. The nearest passport agency is 80 miles away in Detroit — so these mistakes are especially costly here. Here are the most common ones we see from South Central Michigan travelers.",
  testimonialsIntro: "Jackson travelers — from manufacturing professionals to Spring Arbor students to families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Jackson, MI? Here are the most common ones we hear from Jackson County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No driving to Detroit — ship from Jackson", "No appointment wait — we handle submission", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must drive to downtown Detroit — 80+ miles", "Full day commitment — travel, parking, wait time"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Jackson travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute business trips, family emergencies, and Spring Arbor study abroad.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "No need to drive 80 miles to the agency"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Jackson adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Jackson address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Jackson residents and families — including Spring Arbor students, new citizens, and families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Jackson residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Jackson-area families planning international vacations or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Jackson residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Jackson MI", description: "Urgent passport processing for Jackson Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Jackson MI", description: "Fast passport renewal for Jackson Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Jackson MI", description: "New passport application services for Jackson Michigan residents applying for their first passport." },
    { name: "Child Passport Jackson MI", description: "Minor passport services for Jackson Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jennifer K.",
      location: "Jackson, MI",
      rating: 5,
      text: "Study abroad trip in 5 days and my passport was expired. Fast Passport Center handled everything — delivered my renewed passport in 48 hours. I never had to leave Jackson. Saved me from missing my flight.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Mark R.",
      location: "Parma, MI",
      rating: 5,
      text: "Business trip to Toronto in 7 days. First-time passport for me. The process was incredibly smooth — shipped from the UPS on Michigan Ave and had my passport in 4 days. Highly recommend.",
      service: "First-Time Passport",
    },
    {
      name: "Sandra M.",
      location: "Spring Arbor, MI",
      rating: 5,
      text: "Our entire family of four needed passports for a Caribbean cruise. Fast Passport Center got all four done in 6 days. We shipped from the Jackson post office and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Brian D.",
      location: "Michigan Center, MI",
      rating: 5,
      text: "Lost my passport the week before a work trip to Mexico. Fast Passport Center walked me through the DS-64 process and had a replacement in my hands in 36 hours. Outstanding service.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "jackson-1",
      name: "Jackson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "  120 W Michigan Ave",
      city: "Jackson",
      state: "MI",
      zip: "49201",
      phone: "(517) 787-4700",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Jackson — near the County Courthouse",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Jackson acceptance facility. Ample parking. Serves downtown Jackson, Parma, and Michigan Center residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "jackson-2",
      name: "Jackson County Clerk",
      type: "County Clerk Passport Acceptance Facility",
      address: "312 S Jackson St",
      city: "Jackson",
      state: "MI",
      zip: "49201",
      phone: "(517) 788-4265",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Jackson — near the historic courthouse",
      website: "https://www.co.jackson.mi.us/",
      websiteLabel: "Jackson County Clerk",
      notes: "County clerk office offers passport acceptance services. Convenient for downtown workers and residents. Verify current passport hours before visiting.",
      icon: "ri-mail-line",
    },
    {
      id: "jackson-3",
      name: "Spring Arbor Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "105 S Main St",
      city: "Spring Arbor",
      state: "MI",
      zip: "49283",
      phone: "(517) 750-2100",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Spring Arbor — approximately 8 miles southwest of Jackson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Spring Arbor University students and faculty. Small-town office with shorter wait times. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "jackson-4",
      name: "Parma Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 W Main St",
      city: "Parma",
      state: "MI",
      zip: "49269",
      phone: "(517) 531-4110",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "Parma — approximately 15 miles west of Jackson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Small-town acceptance facility. Serves Parma and western Jackson County residents. Limited hours — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "jackson-5",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "211 W. Fort St, Suite 1300",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 80 miles east of Jackson — about 1 hour 15 minutes via I-94",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must drive 80 miles to Detroit", fpc: "No — ship from Jackson County" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Jackson residents are 80 miles from the nearest passport agency — so waiting until the last minute is especially risky. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops in Jackson sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Jackson-area acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Visa Requirements",
      description: "Many Jackson travelers heading to Canada, Mexico, or Europe assume passport validity is the only requirement. Many countries require visas and 6-month validity beyond your return date. Verify all requirements.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — and it's an 80-mile drive from Jackson. Use Fast Passport Center's courier service instead.",
    },
    {
      icon: "ri-truck-line",
      title: "Not Using a Courier for South Central Michigan",
      description: "Jackson residents who drive themselves to the Detroit Passport Agency spend 3+ hours round-trip plus parking and waiting. A courier saves you the entire day and gets faster results.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Jackson County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Jackson, Parma, or Spring Arbor." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no appointment wait or 80-mile drive required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Jackson address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport agency for Jackson residents?", a: "The nearest regional passport agency is the Detroit Passport Agency at 211 W. Fort St, Suite 1300, Detroit, MI 48226 — approximately 80 miles east of Jackson (about 1 hour 15 minutes via I-94). It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access and can skip the appointment backlog — no need for you to drive to Detroit." },
    { q: "How fast can I get an emergency passport in Jackson?", a: "Fast Passport Center offers emergency passport processing in Jackson, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to take a day off work or drive 80 miles to Detroit." },
    { q: "Can I get a passport at the Jackson Post Office?", a: "Yes, the Jackson Post Office at 120 W Michigan Ave offers passport acceptance services Monday through Friday. However, they only process routine and standard expedited applications via mail. For emergency processing within 2 weeks, you will need either an appointment at the Detroit Passport Agency or Fast Passport Center's courier service." },
    { q: "Does Fast Passport Center serve Spring Arbor and Michigan Center?", a: "Absolutely. Fast Passport Center serves all of Jackson County including Spring Arbor, Michigan Center, Parma, Napoleon, Grass Lake, Hanover, Concord, and Springport. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Jackson-area travelers use for international flights?", a: "Jackson County Airport (JXN) is a general aviation airport with no scheduled commercial service. Most Jackson-area travelers use Detroit Metro Wayne County Airport (DTW) — approximately 70 miles east via I-94 — for international flights. Some travelers also use Gerald R. Ford International Airport (GRR) in Grand Rapids, about 90 miles northwest. Lansing's Capital Region International Airport (LAN) offers some regional flights." },
    { q: "How much does an expedited passport cost in Jackson, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Jackson residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Jackson offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Do I need to drive to Detroit for my passport?", a: "No. With Fast Passport Center, you never need to drive to Detroit. We handle everything by courier. You complete your application online, ship your documents from any Jackson-area UPS or FedEx, and our registered courier takes them to the Detroit Passport Agency for you. Your new passport is shipped back to your address." },
  ],
  photoLocations: [
    { name: "Walgreens — Jackson", address: "201 N West Ave, Jackson, MI 49201", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Jackson", address: "1105 W Michigan Ave, Jackson, MI 49202", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Jackson", address: "910 W Ganson St, Jackson, MI 49202", hours: "Mon–Fri: 8AM–6:30PM, Sat: 9AM–4PM" },
    { name: "Jackson County Clerk", address: "312 S Jackson St, Jackson, MI 49201", hours: "Mon–Fri: 8AM–4:30PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Jackson", address: "330 W Michigan Ave, Jackson, MI 49201", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Spring Arbor", address: "107 S Main St, Spring Arbor, MI 49283", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Spring Arbor and southwestern Jackson County communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "JXN",
      name: "Jackson County Airport (Reynolds Field)",
      distance: "5 miles from downtown Jackson — general aviation only",
      address: "3600 Wildwood Ave, Jackson, MI 49202",
      note: "General aviation airport with no scheduled commercial service. Not used for international travel.",
      flightUrl: "https://www.jacksonairport.com/",
      flightLabel: "JXN Airport Info",
      featured: false,
    },
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "Approximately 70 miles east via I-94 — about 1 hour drive",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Jackson-area travelers. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "LAN",
      name: "Capital Region International Airport",
      distance: "Approximately 35 miles north via I-127 — about 40 minutes",
      address: "4100 Capital City Blvd, Lansing, MI 48906",
      note: "Regional airport in Lansing offering some limited international and seasonal flights. Smaller than DTW but closer for some Jackson travelers.",
      flightUrl: "https://www.flylansing.com/",
      flightLabel: "LAN Flight Info",
      featured: false,
    },
  ],
};